export default {
  postTraslado(traslado) {
    return new Promise((resolve, reject) => {
      let ruta = `/api/traslados`;
      return axios.post(ruta, traslado).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      });
    })
  },
  getComprobarEstadoTraslado(persona) {
    return new Promise((resolve, reject) => {
      let ruta = `/api/traslados/personas/${persona}/comprobar`;
      return axios.get(ruta, persona).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      });
    })
  },
  getObtenerResultadoTrasladoXBloque(persona, bloque) {
    return new Promise((resolve, reject) => {
      let ruta = `/api/traslados/personas/${persona}/bloque/${bloque}/respuestas`;
      return axios.get(ruta, persona, bloque).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      });
    })
  },
  getObtenerPDFResultadoTrasladoXBloque(persona, bloque) {
    return new Promise((resolve, reject) => {
      let ruta = `/api/traslados/personas/${persona}/bloque/${bloque}/respuestas/pdf`;
      return axios.get(
        ruta, 
        {
          responseType: "blob" // important
        }
      ).then((response) => {
        resolve(response)
      }, response => {
        resolve(response)
      });
    })
  }
}


